module.exports = __webpack_public_path__ + "static/media/nimes_verteiler.8f79ee24.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Provence/nimes_verteiler.png
// module id = 741
// module chunks = 0